import { twMerge } from 'tailwind-merge';

import { BrandingLogoProps } from './type';

export const BrandingLogo = ({
  src,
  alt,
  className,
  darkThemeSrc,
}: BrandingLogoProps) => {
  return (
    <>
      {src ? (
        <img
          src={src}
          alt={alt}
          className={twMerge(
            'block [html[data-toolpad-color-scheme=dark]_&]:hidden',
            className
          )}
        />
      ) : null}
      {darkThemeSrc ? (
        <img
          alt={alt}
          src={darkThemeSrc}
          className={twMerge(
            'hidden [html[data-toolpad-color-scheme=dark]_&]:block',
            className
          )}
        />
      ) : null}
    </>
  );
};
